module.exports = __webpack_public_path__ + "static/Renesans-Regular-5b95e97bd9c8dd891f8696c55e50bf1f.woff";